/*****
 * 
    Author:	    CT Software Systems, LLC
    Last Modified: 260423
    
*/
'use strict';

import { getGridNavBar } from './ctssGridNavBar.js'; 
import {
    allSettled,
    getPromise,
    savePromise,
    showMySNError
} from './ctssJQuery.js';
import {
    baseURL,
    ImgsFolder,
    appDebugMode,
    getAppToken,
    getImgsBaseURLAsync,
    getTestFolderParams,
    setMenu
} from './snSite.js';
import {
    formatRptData,
    getSermonDataAsync
} from './snSermonsAdd.js';

const { useTestFolder, testFolderParam } = getTestFolderParams();

const token = getAppToken();

const addSermon = () => {
    sessionStorage.setItem('groups', JSON.stringify(groups.filter(x => x.value !== '-1' && x.isActive === true)));
    sessionStorage.setItem('groupID', $('#hiddenGroupID').val());
    sessionStorage.setItem('groupImgsBaseURL', groupImgsBaseURL);
    sessionStorage.setItem('testFolderImgsBaseURL', testFolderImgsBaseURL);
    window.location.href = isGroupLeader ? '../Sermons/GroupLeaderAdd' : '../Sermons/Add';
}
const deleteSermonAsync = async (params) => {

    const { key } = params;
    if (key) {
        await deletePromise({
            url: `Sermons/Sermon/${token.CG}/${key}${testFolderParam}`,
            divErrMsg: 'divDelDlgErrMsg'
        }).then(() => {
            $('#deleteDlg').modal('hide');
            /* Removing from page is faster than going to server to refresh */
            sermons.splice(sermons.findIndex(x => x.id === key), 1);
            $(`#${key}`).remove();
        });

    }
}

const editSermon = (params) => {
    sessionStorage.setItem('groups', JSON.stringify(groups.filter(x => x.value !== '-1' && x.isActive === true)));
    sessionStorage.setItem('groupID', params.groupID);
    sessionStorage.setItem('groupImgsBaseURL', groupImgsBaseURL); 
    sessionStorage.setItem('testFolderImgsBaseURL', testFolderImgsBaseURL);
    sessionStorage.setItem('sid', params.sid);
    window.location.href = isGroupLeader ? '../Sermons/GroupLeaderAdd' : '../Sermons/Add';
};

const getSermonsDataAsync = async () => {

    /* pass token.cg, token.isAdmin, if token.isAdmin = false *
     * pass token.mg for group leader                         */

    const isAdmin = token.IsAdmin === "True";
    let url = `Sermons/${token.CG}/${isAdmin}/AdminMenu`
    if (isAdmin === false) {
        url += `?mg=${token.MG}`
    }

    return await getPromise({ url: url });
}

const getSermonRow = (params) => {

    const {
        id,
        groupID,
        dateGiven,
        title,
        firstNoteIntro
    } = params.sermon;

    let row = '';
    if (groups.length > 0) {
        const g = groups.find(x => x.value === groupID);
        if (g) {
            row += `<tr id="${id}" data-groupid="${groupID}" data-title="${title}">` +
                '<td class="col-md-1 imgDesc-circle-sm" style="padding-left: 10px;">' +
                `<img class="grpImg" data-img_name="${g.imgName}" src="${groupImgsBaseURL}${g.imgName}"></td>` +
                `<td class="col-md-1">${dateGiven}</td>` +
                `<td class="col-md-5">${title}</td>` +
                `<td class="col-md-4">${firstNoteIntro}</td>` +
                `<td class="col-md-1 text-right">` +
                `<span data-action="edit" class="fa fa-pencil mRight10"></span>` +
                `<span data-action="print" class="fa fa-print mRight10"></span></td>` +
                '</tr>';
        }
    } else {
        row += `<tr id="${id}" data-title="${title}">` +
            `<td class="col-md-2">${dateGiven}</td>` +
            `<td class="col-md-5">${title}</td>` +
            `<td class="col-md-4">${firstNoteIntro}</td>` +
            '<td class="col-md-1 text-right">' +
            `<span data-action="edit" class="fa fa-pencil mRight10"></span>` +
            `<span data-action="print" class="fa fa-print mRight10"></span></td>` +
            '</tr>';
    }
    return row;
}

const getSermonRows = (params = {}) => {
    const {
        sourceArray = sermons, /* could be filtered array of group sermons */   
        pageIdx,
        totalRows
    } = params;


    let content = '';
    const endIdx = (totalRows - pageIdx > pageSize)
        ? pageIdx + pageSize
        : pageIdx + totalRows - pageIdx;
    for (let i = pageIdx, l = endIdx; i < l; i++) {
        //content += getSermonRow({ sermon: params.rows[i] });
        content += getSermonRow({ sermon: sourceArray[i] });
    }
    currentIdx = endIdx;
    $('#gridSermons tbody').html(content);
    $('#gridSermons tbody .grpImg').off('error').on('error', (e) => {
        e.target.src = `${testFolderImgsBaseURL}${e.target.dataset.img_name}`;
    });
};

const initDeleteDlg = () => {
    $('#deleteDlg').on('show.bs.modal', (e) => {
        const key = e.relatedTarget.dataset.key;
        const sermon = sermons[sermons.findIndex(x => x.id === key)];
        $('#deletePrompt').text('Are you sure you want to delete the ' + sermon.title + ' sermon?');
        $('#btnDelete').off('click').click(async () => { await deleteSermonAsync({ key: key }) });
    });
}

const initSermonsGrid = (params) => {

    const getAddSermonBtn = () =>
        '<button id="btnAddSermon" class="btn btn-sm pull-right">' +
        '   <span class="fa fa-plus"></span> Add Sermon' +
        '</button>';

    let content;
    if (params.hasGroups) {
        content = '<tr>' +
            '<th class="col-md-1">Group</th>' +
            '<th class="col-md-1">Sermon Date</th>' +
            '<th class="col-md-5">Title</th>' +
            '<th class="col-md-4">Content</th>' +
            `<th class="col-md-1">${getAddSermonBtn()}</th>` +
            '</tr>';
    }
    else {
        content = '<tr>' +
            '<th class="col-md-2">Sermon Date</th>' +
            '<th class="col-md-5">Title</th>' +
            '<th class="col-md-4">Content</th>' +
            `<th class="col-md-1">${getAddSermonBtn()}</th>` +
            '</tr>';
    }
    $('#gridSermons thead').empty().append(content);
    $('#btnAddSermon').on('click', addSermon); 
}

const initSermonsToolBar = (params) => {
    if (params.hasGroups) {
        $('#hiddenGroupID').val('-1');
        $('#btnImgsDDL img').off('error').on('error', (e) => {
            e.target.src = `${testFolderImgsBaseURL}${groups[0].imgNname}`;
        });
        $('#btnImgsDDL').html(`<img src="${groupImgsBaseURL}${groups[0].imgName}"> ${groups[0].text} <span class="caret"></span></span>`);
        const content = groups.reduce((acc, g) => {
            return acc + `<li data-group_id="${g.value}" class="dropdown-item">` +
                `<img class="grpImg" src="${groupImgsBaseURL}${g.imgName}" data-group_id="${g.value}" data-img_name="${g.imgName}">${g.text}</li>`;
        }, '');
        $('#divImagesDDL .dropdown-menu').html(content);
        $('#divImagesDDL .dropdown-menu .grpImg').off('error').on('error', (e) => {
            e.target.src = `${testFolderImgsBaseURL}${e.target.dataset.img_name}`;
        });
        $('#divImagesDDL .dropdown-menu > li').off('click').click(e => {
            const g = groups[groups.findIndex(x => x.value === e.target.dataset.group_id)];
            $('#hiddenGroupID').val(g.value);
            $('#btnImgsDDL').html(`<img src="${groupImgsBaseURL}${g.imgName}"> ${g.text} <span class="caret"></span></span>`);
            $('#btnImgsDDL img').off('error').on('error', (e) => {
                e.target.src = `${testFolderImgsBaseURL}${g.imgName}`;
            });
            if (g.value === '-1') {
                $('#lblSortedBy,#ddlSortBy').removeClass('hidden');
                currentIdx = 0;
                totalRows = sermons.length;
                refreshGridAndNavBar({ pageIdx: 0, totalRows });
            } else {
                $('#lblSortedBy,#ddlSortBy').addClass('hidden');                
                const groupSermons = sermons.filter(x => x.groupID === g.value);
                currentIdx = 0;
                totalRows = groupSermons.length;
                refreshGridAndNavBar({ sourceArray: groupSermons, pageIdx: 0, totalRows });
                if (g.isActive === false) {
                    $('#btnAddSermon')
                        .prop("disabled", true)
                        .attr('title', 'You cannot add a sermon because the group has been deleted...');
                } else {
                    $('#btnAddSermon')
                        .prop("disabled", false)
                        .removeAttr('title');
                }
            }
        });
        $('#sermonsToolBar').removeClass('hidden');
    }
}

const printSermon = (params) => {

    /* Set event handler for selected sermon */

    $('#btnPrint').off('click').on('click', async () => {
        let lines = $('input[name="rptLines"]:checked').val();
        if (lines === "customLines") {
            lines = $('#customLines').val();
        }

        try {
            const sermonData = await getSermonDataAsync({ sermonID: params.sid });

            const g = groups.find(x => x.value === params.groupID);
            
            sessionStorage.setItem('baseURL', baseURL);
            sessionStorage.setItem('church', token.Church);
            sessionStorage.setItem('groupID', params.groupID);
            sessionStorage.setItem('groupImgName', `${groupImgsBaseURL}${g.imgName}`);
            sessionStorage.setItem('groupName', g.text);

            const rptData = formatRptData({ sermonDtls: sermonData.sermonDtls });

            const noteObjects = await savePromise({
                url: `Sermons/FormatDraftSermonDtlForRpt/${lines}`,
                data: rptData
            });

            sessionStorage.setItem('noteObjects', JSON.stringify(noteObjects));
            sessionStorage.setItem('subTitle', sermonData.subTitle);
            sessionStorage.setItem('title', sermonData.title);

            const url = `../Reports/SermonDraft?title=${sermonData.title}`;
            window.open(url, '_blank');

        } catch (error) {
            console.log(error);
            showMySNError({ errMsg: 'Unable to retrieve report data. Please contact support@mysermonnotes.com...' })
        }

        $('#printDlg').modal('hide');

    });

    $('#printDlg').modal('show');
};

const refreshGridAndNavBar = (params) => {
    getSermonRows(params);
    getGridNavBar({
        getRowFn: (params) => getSermonRows(params),
        getGridStateFn: () => {
            return {
                currentIdx,
                pageSize,
                totalRows
            };
        }
    });
}

let groups = [];
let groupImgsBaseURL = '';
let isGroupLeader;
let sermons = [];
let pageSize = 10;
let currentIdx = 0;
let totalRows;
let testFolderImgsBaseURL = '';

const initAsync = async () => {

    isGroupLeader = token.IsAdmin === "False" && token.GroupLeaderRights.length > 0;
    setMenu();

    const [gImgsBaseURL,
        sermonsData,
        tImgsBaseURL
    ] = await allSettled({
        promises: [
            getImgsBaseURLAsync(ImgsFolder.Groups),
            getSermonsDataAsync(),
            getImgsBaseURLAsync(ImgsFolder.TestFolder),
        ]
    });

    if (gImgsBaseURL.status !== 'rejected') {
        groupImgsBaseURL = gImgsBaseURL.value;
    }
    if (tImgsBaseURL.status !== 'rejected') {
        testFolderImgsBaseURL = tImgsBaseURL.value;
    }
    if (sermonsData.status !== 'rejected') {
        const hasGroups = sermonsData.value.hasGroups;
        groups = sermonsData.value.groups ?? [];
        sermons = sermonsData.value.sermons ?? [];
        totalRows = sermons.length;
        initSermonsToolBar({ hasGroups });
        initSermonsGrid({ hasGroups });
        refreshGridAndNavBar({ pageIdx: 0, totalRows });
    };

    initDeleteDlg();

    $('#ddlSortBy').on('change', (e) => {
        if (e.target.value === '1') {
            sermons.sort((a, b) => new Date(b.dateGiven) - new Date(a.dateGiven));
        } else {
            sermons.sort((a, b) => a.groupDisplayOrder - b.groupDisplayOrder || new Date(b.dateGiven) - new Date(a.dateGiven));
        }
        refreshGridAndNavBar({ pageIdx: 0, totalRows });
    });

    $('#gridSermons tbody').on('click', (e) => {

        const action = e.target.dataset.action;
        const tr = e.target.closest('tr');
        const sid = tr.id;

        /* html data attribute naming convention is data-skdj all    *
         * lowercase letters which doesn't match as groupID variable * 
         * expected by other javascript functions                    */

        const groupID = tr.dataset.groupid ?? '0';
        const title = tr.dataset.title;
        if (action === 'edit') {
            editSermon({ sid, groupID });
        } else if (action === 'print') {
            printSermon({ sid, groupID, title });
        }
    });
};

window.snSermonsEdit = {
    initAsync
}
